import "./App.css";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactNotifications } from "react-notifications-component";
import { SnackbarProvider } from "notistack";
import { StdLive, StdLiveHybrid } from "./LiveTracker/StdLive";
import Aboutsus from "./Pages/Aboutus";
import AcessList from "./Pages/AcessList";
import AddCourses from "./Pages/AddCourses";
import AddQuestions from "./Pages/AddQuestions";
import AdminSlider from "./componentsofcourse/AdminSlider";
import AggregationPages from "./Pages/AggregationPages";
import AllCourseContextProvider from "./Context/AllCourse";
import Allcourses from "./componentsofcourse/Allcourses";
import AllenrolledStudents from "./Pages/AllenrolledStudents";
import AlllTablequizresultsbybatch from "./Pages/AlllTablequizresultsbybatch";
import AllTablehybridresultsbybatch from "./Pages/AllTablehybridresultsbybatch";
import AttendanceUpload from "./components/AttendanceUpload";
import AuthContextProvider from "./Context/AuthContext";
import B2BHome from "./Pages/B2BHome";
import BlogPage from "./Pages/BlogPage";
import BulkQuizUpload from "./Pages/BulkQuizUpload";
import ChartComponent from "./components/Admin/ChartComponent";
import CheckCourses from "./Pages/CheckCourses";
import CodingEdit from "./Pages/CodingEdit";
import CodingExamCreating from "./components/CodingExamCreating";
import CodingExamResults from "./Pages/CodingexamResults";
import CodingQuesForm from "./components/CodingQuesForm";
import CollegeDetails from "./componentsofcourse/CollegeDetails";
import Comingsoon from "./Pages/coming soon";
import CompanySpecificSummer from "./Pages/CompanySpecificSummer";
import ContentDetail from "./Pages/AddData/ContentDetail";
import CouponCreating from "./Pages/CouponCreating";
import CoursesDashboard from "./components/CoursesDashboard";
import CourseTestUpdate from "./Pages/CourseTestUpdate";
import CourseUploadForm from "./componentsofcourse/CourseUploadForm";
import CourseVideo from "./componentsofcourse/CourseVideo";
import CPcourse from "./Pages/CPcourse";
import CreateCoding from "./Pages/CodingQuestion/CreateCoding.tsx";
import CreateProject from "./Pages/CreateProject";
import CreateSubProject from "./Pages/CreateSubProject";
import CreateWeeklyContent from "./Pages/CreateWeeklyContent";
import DashboardProjects from "./Pages/DashboardProjects";
import DashboardSettings from "./Pages/DashboardSettings";
import DeleteProject from "./Pages/DeleteProject";
import DeleteSubProject from "./Pages/DeleteSubProject";
import Demo from "./components/Admin/Demo";
import DummyForm from "./Pages/DummyForm";
import Edit from "./components/Edit";
import EditSubTopics from "./Pages/EditSubTopics";
import EnrollTheUser from "./components/EnrollTheUser";
import ForbiddenPage from "./components/ForbiddenPage";
import FormUpload from "./Pages/AddData/FormUpload";
import GetAllQuestions from "./Pages/GetAllQuestions";
import GetAssignmentQuestions from "./Pages/GetAssignmentQuestions";
import GetAssignmentTypes from "./Pages/GetAssignmentTypes";
import GetWeeklyContent from "./Pages/GetWeeklyContent";
import Home from "./Pages/Home"; //
import HybridExam from "./Pages/HybridExam";
import Hybridexambybatches from "./Pages/Hybridexambybatches";
import HybridExamCreating from "./components/HybridExamCreating";
import Hybridexamsbybatches2 from "./Pages/Hybridexamsbybatches2";
import Hybridexamscore from "./Pages/Hybridexamscore";
import ImgSlider from "./componentsofcourse/ImgSlider";
import InternalForm from "./components/InternalForm";
import JobPostingData from "./Pages/JobPostingData";
import JobPostingPage from "./Pages/JobPostingPage";
import JobPostings from "./Pages/JobPostings";
import LiveGroups from "./Pages/LiveGroups";
import MasterClass from "./Pages/MasterClass";
import MasterClassPage from "./Pages/MasterClassPage";
import MentorShip from "./Pages/MentorShip";
import ModalContextProvider from "./Context/ModalContext";
import MyCourse from "./componentsofcourse/MyCourse";
import Others from "./componentsofcourse/Others";
import Overview from "./Pages/Overview";
import OverviewForm from "./Pages/OverviewForm";
import Particulardata from "./components/Particulardata";
import PaymentPopup from "./Pages/PaymentPopup";
import PDOnlineCards from "./Pages/PDOnlineCards";
import Personalinformation from "./componentsofcourse/Personalinformation";
import PlacementCourse from "./Pages/PlacementCourse";
import PlacementForm from "./Pages/PlacementForm";
import Profile from "./components/Profile";
import ProtectedRoutes from "./Pages/ProtectedRoutes";
import Qotd from "./Pages/Qotd";
import QuestionForm from "./components/QuestionForm";
import Quiz from "./Pages/Quiz";
import QuizEdit from "./Pages/QuizEdit";
import QuizEditForm from "./Pages/QuizEditForm";
import QuizEditor from "./Pages/QuizEditor";
import QuizEditPage from "./Pages/QuizEditPage";
import Quizexambybatches from "./Pages/Quizexambybatches";
import QuizExamCreating from "./components/QuizExamCreating";
import QuizExamEdit from "./Pages/QuizExamEdit";
import QuizExamResults from "./Pages/QuizexamResults";
import QuizQuestionForm from "./Pages/QuizQuestionForm";
import QuizResult from "./Pages/QuizResult";
import QuizScore from "./Pages/QuizScore";
import QuizUpdate from "./Pages/QuizUpdate";
import ResetPassword from "./components/ResetPassword";
import Resetpasswordus from "./Pages/Resetpasswordus";
import RouteGuard from "./RouteGuard";
import ShowAllCourseId from "./Pages/ShowAllCourseId";
import ShowAllCourses from "./Pages/ShowAllCourses";
import SignIn from "./Pages/SignIn";
import SignupAndEnrolling from "./components/SignupAndEnrolling";
import SingleCourseDashboard from "./components/SingleCourseDashboard";
import SpecificUserData from "./Pages/SpecificUserData";
import StudentCourseResults from "./Pages/StudentCourseResults";
import SuperAdmin from "./components/Admin/SuperAdmin";
import Support from "./Pages/Support";
import Table from "./components/Table.js";
import Token from "./Token";
import UpdateQuizTime from "./Pages/updateQuizTime";
import UploadVideo from "./Pages/AddData/UploadVideo";
import UserDashboardPage from "./components/Admin/UserDashboardPage";
import UserDataPage from "./Pages/UserDataPage";
import Viewvideo from "./componentsofcourse/Viewvideo";
import Web from "./Pages/webCourse";
import WeeklyContextProvider from "./Context/WeeklyContext";
import DashboardTemplate from "./Pages/DashboardTemplate";
import EmailTemplate from "./Pages/EmailTemplate";

const queryClient = new QueryClient();

function App() {
	return (
		<QueryClientProvider client={queryClient}>
			<SnackbarProvider>
				<div className="App">
					<Router>
						<AuthContextProvider>
							<ModalContextProvider>
								<AllCourseContextProvider>
									<WeeklyContextProvider>
										<ReactNotifications />
										<Token />
										<RouteGuard>
											<Switch>
												<Route path="/student-course-results">
													<StudentCourseResults />
												</Route>
												<Route path="/coding-test-update">
													<CourseTestUpdate />
												</Route>
												<Route path="/resetpassword-new">
													<Resetpasswordus />
												</Route>
												<Route path="/showallcourses-develop">
													<ShowAllCourses />
												</Route>
												<Route path="/showallcourseid/:id">
													<ShowAllCourseId />
												</Route>
												<Route path="/quizEditform/:id">
													<QuizEditForm />
												</Route>
												<Route path="/bulk-enroll-sign-the-user">
													<SignupAndEnrolling />
												</Route>
												<Route path="/creating-an-exam">
													<CodingExamCreating />
												</Route>
												<Route path="/dashboard-template">
													<DashboardTemplate />
												</Route>
												<Route path="/all-enroll-students">
													<AllenrolledStudents />
												</Route>
												<Route path="/upload-attendance">
													<AttendanceUpload />
												</Route>
												<Route path="/quiz-form-edit/creating-an-quiz-exam">
													<QuizExamCreating />
												</Route>
												<Route path="/quiz-form-edit/edit-quiz">
													<QuizEditPage />
												</Route>
												<Route path="/hybridexambybatches">
													<Hybridexambybatches />
												</Route>
												<Route
													exact
													path="/quizexambatches"
												>
													<Quizexambybatches />
												</Route>
												<Route path="/allbatcheshybrid/:batch">
													<Hybridexamsbybatches2 />
												</Route>
												<Route path="/alltableresultsbyassignments">
													<AllTablehybridresultsbybatch />
												</Route>
												<Route path="/quizexambatches/:examId">
													<AlllTablequizresultsbybatch />
												</Route>
												<Route
													path="/creating-a-hybrid-exam"
													component={
														HybridExamCreating
													}
												/>
												<Route path="/coupon-creating-small">
													<CouponCreating />
												</Route>
												<Route path="/bulkquizupload">
													{" "}
													<BulkQuizUpload />{" "}
												</Route>
												<Route path="/quizResult">
													<QuizResult />
												</Route>
												<Route path="/codingexamresults">
													<CodingExamResults />
												</Route>
												<Route path="/quizexam-results">
													<QuizExamResults />
												</Route>
												<Route path="/quiz-examedit">
													<QuizExamEdit />
												</Route>
												<Route path="/quiz-edit/:id">
													<QuizEdit />
												</Route>
												<Route path="/quiz-score/:id">
													<QuizScore />
												</Route>
												<Route path="/enroll-the-user">
													<EnrollTheUser />
												</Route>
												<Route
													exact
													path="/CoursesDashboard"
												>
													<CoursesDashboard />
												</Route>
												<Route path="/Table">
													<Table />
												</Route>
												<Route path="/Hybridexamscore">
													<Hybridexamscore />
												</Route>
												<Route path="/demoPage">
													<Demo />
												</Route>
												<Route path="/CoursesDashboard/:course">
													<SingleCourseDashboard />
												</Route>
												<Route path="/chart">
													<ChartComponent />
												</Route>
												<Route path="/internal-form">
													<InternalForm />
												</Route>
												<Route
													path="/dummyForm"
													component={DummyForm}
												/>
												<Route path="/allcourses">
													<Allcourses />
												</Route>
												<Route
													path="/placementform"
													component={PlacementForm}
												/>
												<Route path="/viewvideo">
													<Viewvideo />
												</Route>
												<Route path="/createJobPosting">
													<JobPostings />
												</Route>
												<Route
													exact
													path="/adminslider"
													component={AdminSlider}
												/>
												<Route
													exact
													path="/uploadCourseVideo"
													component={CourseVideo}
												/>
												<Route
													exact
													path="/imgSlider"
													component={ImgSlider}
												/>
												<Route
													exact
													path="/jobposting"
													component={JobPostingPage}
												/>
												<Route
													exact
													path="/jobposting/:id"
													component={JobPostingData}
												/>
												<Route
													exact
													path="/aggregations"
													component={AggregationPages}
												/>
												<Route path="/personal">
													<Personalinformation />
												</Route>
												<Route path="/collegeDetails">
													<CollegeDetails />
												</Route>
												<Route path="/others">
													<Others />
												</Route>
												<Route path="/uploadCourse">
													<CourseUploadForm />
												</Route>
												<Route
													path="/b2bHome"
													component={B2BHome}
												/>
												<Route
													path="/blogs/:id"
													component={BlogPage}
												/>
												<Route
													exact
													path="/user/:id"
													component={Profile}
												/>
												<Route
													exact
													path="/"
													component={Home}
												/>
												<Route
													exact
													path="/edit"
													component={Edit}
												/>
												<Route
													path={"/particulardata/:id"}
												>
													<Particulardata />
												</Route>
												<Route path="/Aboutus">
													<Aboutsus />
												</Route>
												<Route path="/masterclass">
													<MasterClass />
												</Route>
												<Route path="/masterclasspage">
													<MasterClassPage />
												</Route>
												<Route
													path="/order/:id"
													component={PaymentPopup}
												/>
												<Route
													path="/mycourse"
													component={MyCourse}
												/>
												<Route path="/webcourse">
													<Web />
												</Route>
												<Route path="/cpcourse">
													<CPcourse />
												</Route>
												<Route path="/placementcourse">
													<PlacementCourse />
												</Route>
												<Route path="/overview">
													<Overview />
												</Route>
												<Route path="/add-questions">
													<AddQuestions />
												</Route>
												<Route path="/support">
													<Support />
												</Route>
												<Route path="/signin">
													<SignIn />
												</Route>
												<Route path="/quiz">
													<Quiz />
												</Route>
												<Route path="/questionForm">
													<QuestionForm />
												</Route>
												<Route path="/codingquesform">
													<CodingQuesForm />
												</Route>
												<Route path="/coding-edit/:codingId">
													<CreateCoding />
												</Route>
												<Route path="/coding-edit">
													<CodingEdit />
												</Route>
												<Route path="/quizquestionform">
													<QuizQuestionForm />
												</Route>
												<Route path="/accessList">
													<AcessList />
												</Route>
												<Route path="/coursesCheck">
													<CheckCourses />
												</Route>
												<Route path="/addCourses">
													<AddCourses />
												</Route>
												<Route
													exact
													path="/superadmin"
													component={SuperAdmin}
												/>
												<ProtectedRoutes
													path="/studentlive/:_id"
													component={StdLive}
												/>

												<ProtectedRoutes
													path="/hybrid-exam-live/:_id"
													component={StdLiveHybrid}
												/>

												<ProtectedRoutes
													exact
													path="/get-user-data"
													component={UserDataPage}
												/>

												<ProtectedRoutes
													path="/get-user-data/:userId"
													component={SpecificUserData}
												/>

												<ProtectedRoutes
													path="/live-groups/:id"
													component={LiveGroups}
												/>

												<Route
													exact
													path="/dashboard/user/:page"
													component={
														UserDashboardPage
													}
												/>
												<Route
													exact
													path="/video-upload"
													component={UploadVideo}
												/>
												<Route
													exact
													path="/video-upload/add-learning-card"
													component={FormUpload}
												/>
												<Route
													exact
													path="/video-upload/:_id"
													component={ContentDetail}
												/>
												<Route
													exact
													path="/updateQuiz"
													component={UpdateQuizTime}
												/>
												<Route
													exact
													path="/quizUpdate/:_id"
													component={QuizUpdate}
												/>
												<Route
													exact
													path="/resetpassword/:_id/:token"
													component={ResetPassword}
												/>
												<Route
													exact
													path="/hybrid-exam"
													component={HybridExam}
												/>
												<Route
													exact
													path="/hybrid-exam-edit/:examId"
													component={HybridExam}
												/>
												<Route
													exact
													path="/edit-subtopics"
													component={EditSubTopics}
												/>
												<Route
													exact
													path="/create-coding-question"
													component={CreateCoding}
												/>
												<Route
													exact
													path="/create-email-template"
													component={EmailTemplate}
												/>
												<Route
													exact
													path="/create-coding-question-dup"
													component={CreateCoding}
												/>
												<Route
													path="/overviewform"
													component={OverviewForm}
												/>
												<Route
													path="/qotd"
													component={Qotd}
												/>
												<Route
													exact
													path="/mentorship"
													component={MentorShip}
												/>
												<Route
													exact
													path="/dashboardprojects"
													component={
														DashboardProjects
													}
												/>
												<Route
													exact
													path="/dashboardprojects/create-project"
													component={CreateProject}
												/>
												<Route
													exact
													path="/dashboardprojects/delete-project"
													component={DeleteProject}
												/>
												<Route
													exact
													path="/dashboardprojects/create-sub-project"
													component={CreateSubProject}
												/>
												<Route
													exact
													path="/dashboardprojects/delete-sub-project"
													component={DeleteSubProject}
												/>

												<Route
													exact
													path="/quiz-form-edit"
													component={QuizEditor}
												/>
												<Route
													exact
													path="/pdonlinecards/create-weekly-content"
													component={
														CreateWeeklyContent
													}
												/>
												<Route
													exact
													path="/pdonlinecards/get-weekly-content"
													component={GetWeeklyContent}
												/>
												<Route
													exact
													path="/get-assignment-types:_id"
													component={
														GetAssignmentTypes
													}
												/>
												<Route
													exact
													path="/get-assignment-questions:_id/:id"
													component={
														GetAssignmentQuestions
													}
												/>

												<Route
													exact
													path="/get-all-questions"
													component={GetAllQuestions}
												/>

												<Route
													exact
													path="/pdonlinecards"
													component={PDOnlineCards}
												/>

												<Route
													exact
													path="/dashboard-settings"
													component={
														DashboardSettings
													}
												/>

												<Route exact path="/">
													<Comingsoon />
												</Route>

												<Route exact path="/css/*">
													<CompanySpecificSummer />
												</Route>
												<Route path="/forbidden">
													<ForbiddenPage />
												</Route>
											</Switch>
										</RouteGuard>
									</WeeklyContextProvider>
								</AllCourseContextProvider>
							</ModalContextProvider>
						</AuthContextProvider>
					</Router>
				</div>
			</SnackbarProvider>
		</QueryClientProvider>
	);
}

export default App;
